import { api } from './api';

export type RetryResult = { ok: true; newId: number } | { ok: false; message: string };

// POST /recognitions/:id/retry 只负责入队,立即返回新 recognition_id。
export async function retryRecognition(id: number): Promise<RetryResult> {
  const r = await api<{ recognition_id: number; status: string }>(
    `/api/v1/recognitions/${id}/retry`,
    { method: 'POST' },
  );
  if (!r.ok) return { ok: false, message: r.error.message || '重新识别失败' };
  return { ok: true, newId: r.data.recognition_id };
}
